import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { AmplifyHttpClient } from '../auth/http.amplify-httpclient';

@Injectable({
  providedIn: 'root'
})
export class PostService {

  constructor(private readonly httpService: AmplifyHttpClient, ) { }

  createAlbum(request) {
    return this.httpService.post<any>(`api/album`, request).pipe(
      map(response => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      }),
    );
  }

  createPost(request){
    return this.httpService.post<any>(`api/post`, request).pipe(
      map(response => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      }),
    );
  }

  getYourStories(request){
    return this.httpService.get<any>(`api/post`, {params : request}).pipe(
      map(response => {
        return response;
      }),
    ).toPromise()
    .then((data: any) => {
      return data;
    }).catch((error) => {
      throw error;
    });
  }
  getUsersAllPost(request){
    return this.httpService.get<any>(`api/post/all`, { params: request }).pipe(
      map(response => {
        return response;
      }),
    ).toPromise()
      .then((data: any) => {
        return data;
      }).catch((error) => {
        throw error;
      });
  }
}
